import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';
import buttonFields from './helpers/buttonFields';

const GFIModelSections: IModel = {
  title: 'Model Sections',
  apiPath: 'system/models/{id}/sections',
  forms: {
    insert: {
      fields: ['title_token', 'sortorder'],
    },
    update: {
      fields: ['title_token', 'sortorder'],
    },
  },
  listViews: {
    default: {
      fields: [
        'id',
        'model_id',
        'title_token',
        'sortorder',
        'created_on',
        'created_by',
        'modified_on',
        'modified_by',
        'edit',
      ],
    },
  },
  fields: [
    coreFields.id,
    coreFields.created_on,
    coreFields.created_by,
    coreFields.modified_on,
    coreFields.modified_by,
    {
      title: 'model_id',
      source: 'model_id',
      ttoken: 'admin:common.model_id',
      type: 'numeric',
      validation: {
        required: true,
      },
    },
    {
      title: 'title_token',
      source: 'title_token',
      ttoken: 'admin:model_sections.title_token',
      type: 'text',
      validation: {
        required: true,
        maxLength: 50,
      },
    },
    {
      title: 'sortorder',
      source: 'sortorder',
      ttoken: 'core:common.sortorder',
      type: 'numeric',
    },
    buttonFields.edit,
  ],
};

export default GFIModelSections;
